<template lang="pug">
  v-card.round-2xl.neutral200.pa-2(outlined)
    div.d-flex.align-center.justify-space-between
      div
        .text-xs.neutral700--text.font-semibold {{ title }}
        .text-xxs.neutral700--text {{ subtitle }}
      y-button(label="Apply" size="xxs" height="24" unset-min-width button-class="px-2" @click="handleApply")
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
  },
  methods: {
    handleApply () {
      this.$emit('apply')
    }
  },
}
</script>

<style scoped>
</style>